import styled from 'styled-components'

import List from '../List'

const Menu = styled(List)`
  z-index: 1000;
  min-width: 100%;
  border: 1px solid ${props => props.theme.colors.gray600};
  background-color: ${props => props.theme.colors.white};

  max-height: 300px;
  overflow-y: auto;
`

export default Menu
